import React from "react";
import { Link } from "react-router-dom";
import { Lightbulb } from "lucide-react";

export default function InsightsPanel({ insights }) {
  if (!insights?.length) return null;

  const chipClass =
    "shrink-0 text-xs font-medium px-3 py-1.5 rounded-full border border-[#A78BFA]/40 text-[#A78BFA] hover:bg-[#A78BFA]/10 transition-colors";

  return (
    <section data-testid="dashboard-insights" className="border border-white/10 bg-[#111113] rounded-2xl p-5 sm:p-6">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2 mb-4">
        <Lightbulb className="w-4 h-4 text-[#F59E0B]" /> Today's Insights
      </h2>
      <div className="space-y-3">
        {insights.map((ins) => (
          <div
            key={ins.id}
            data-testid={`insight-${ins.id}`}
            className="flex items-center justify-between gap-3 border border-white/5 bg-white/[0.02] rounded-xl px-4 py-3 hover:bg-white/[0.05] transition-colors"
          >
            <div className="flex items-center gap-3 min-w-0">
              <ins.icon className="w-4 h-4 text-[#A78BFA] shrink-0" />
              <p className="text-sm text-zinc-300">{ins.text}</p>
            </div>
            {ins.to ? (
              <Link to={ins.to} data-testid={`insight-action-${ins.id}`} className={chipClass}>
                {ins.actionLabel}
              </Link>
            ) : (
              <button onClick={ins.onAction} data-testid={`insight-action-${ins.id}`} className={chipClass}>
                {ins.actionLabel}
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
